import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import Spacer from '../components/spacer';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    minHeight: '100vh',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    [theme.breakpoints.up('sm')]: {
      minHeight: 400,
      height: '80vh'
    },
    [theme.breakpoints.up('md')]: {
      minHeight: 500
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 606
    }
  }
}));

const PresentationBlock = ({ children, className }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)}>
      <Spacer />
      {children}
    </div>
  );
};

PresentationBlock.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

PresentationBlock.defaultProps = {
  className: ''
};

export default PresentationBlock;
